"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _file = require("FileManagerCore/utils/file");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIConfirmModal = _interopRequireDefault(require("UIComponents/dialog/UIConfirmModal"));

function getI18nKey(suffix) {
  return "FileManagerCore.deleteModal." + suffix;
}

var DeleteFileModal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DeleteFileModal, _Component);

  function DeleteFileModal() {
    (0, _classCallCheck2.default)(this, DeleteFileModal);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeleteFileModal).apply(this, arguments));
  }

  (0, _createClass2.default)(DeleteFileModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onCancel = _this$props.onCancel,
          onDelete = _this$props.onDelete,
          file = _this$props.file;
      return _react.default.createElement(_UIConfirmModal.default, {
        confirmLabel: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('deleteFileConfirmLabel')
        }),
        rejectLabel: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('cancel')
        }),
        confirmUse: "danger",
        rejectUse: "tertiary-light",
        width: 600,
        description: _react.default.createElement("div", null, _react.default.createElement(_FormattedHTMLMessage.default, {
          message: getI18nKey('deleteFileDescription'),
          options: {
            name: file.get('name')
          }
        }), _react.default.createElement("div", {
          className: "m-top-3"
        }, _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "FileManagerCore.deleteModal.fileMightBeUsed",
          options: {
            href: (0, _file.getFileDetailsFileManagerAppLink)(file)
          }
        }))),
        message: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('deleteFileMessage')
        }),
        use: "danger",
        onConfirm: onDelete,
        onReject: onCancel
      });
    }
  }]);
  return DeleteFileModal;
}(_react.Component);

exports.default = DeleteFileModal;
DeleteFileModal.propTypes = {
  file: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  onDelete: _react.PropTypes.func.isRequired,
  onCancel: _react.PropTypes.func.isRequired
};
module.exports = exports.default;